import { render, staticRenderFns } from "./UpdatedArticle.vue?vue&type=template&id=5b5171c2&scoped=true&"
import script from "./UpdatedArticle.vue?vue&type=script&lang=js&"
export * from "./UpdatedArticle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b5171c2",
  null
  
)

export default component.exports